import './App.css';
import Hero from './components/Hero';
import Programs from './components/programs/programs';
import Reasons from '../src/components/Reasons/Reasons';
import Plans from '../src/components/Plans/Plans'
import Testimonials from './components/Testimonials/Testimonials';
import Join from './components/Join/Join'
import Footer from './components/Footer/Footer';


function App() {
  return (
    <div className="App">
        <Hero/>
        <Programs/>
        <Reasons/>
        <Plans/>
        <Testimonials/>
        <Join/>
        <Footer/>
        




           </div>
  );
}

export default App;
